import api from "../services/api";
 
// Users
export const updateUserStatus = (data) => {
    return api.put('admin/user/status', data);
}

export const getUserList = (queryParams) => {
    return api.get(`admin/user/list${queryParams}`);
};

export const getUserDetails = (queryParams) => {
    return api.get(`admin/user/details${queryParams}`);
};